import { useEffect, useState } from "react";
import { MOCK_DATA } from "./mockData";

const listeners = new Set();

export function bumpMockData() {
  listeners.forEach((listener) => listener());
}

export function useMockDataVersion() {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    const listener = () => setVersion((v) => v + 1);
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);
  return version;
}

export { MOCK_DATA };
